var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRectangleonrectangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.398 31.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-rectangle-on-rectangle-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.734 31.523L33.418 31.523C36.738 31.523 38.398 29.883 38.398 26.621L38.398 12.246C38.398 8.965 36.738 7.344 33.418 7.344L12.734 7.344C9.395 7.344 7.754 8.965 7.754 12.246L7.754 26.621C7.754 29.902 9.395 31.523 12.734 31.523Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-rectangle-on-rectangle-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98 24.18L25.684 24.18C28.984 24.18 30.664 22.559 30.664 19.277L30.664 4.922C30.664 1.641 28.984 0 25.684 0L4.98 0C1.641 0 0 1.641 0 4.922L0 19.277C0 22.559 1.641 24.18 4.98 24.18ZM5.02 21.367C3.613 21.367 2.812 20.605 2.812 19.121L2.812 5.059C2.812 3.574 3.613 2.832 5.02 2.832L25.645 2.832C27.031 2.832 27.832 3.574 27.832 5.059L27.832 19.121C27.832 20.605 27.031 21.367 25.645 21.367Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.734 31.523L33.418 31.523C36.738 31.523 38.398 29.883 38.398 26.621L38.398 12.246C38.398 8.965 36.738 7.344 33.418 7.344L12.734 7.344C9.395 7.344 7.754 8.965 7.754 12.246L7.754 26.621C7.754 29.902 9.395 31.523 12.734 31.523ZM12.773 28.711C11.367 28.711 10.566 27.949 10.566 26.465L10.566 12.402C10.566 10.918 11.367 10.156 12.773 10.156L33.379 10.156C34.785 10.156 35.586 10.918 35.586 12.402L35.586 26.465C35.586 27.949 34.785 28.711 33.379 28.711Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleonrectangle);
export default __webpack_public_path__ + "static/media/rectangle.on.rectangle.522375ba90a7aebc47ca6a07a719768f.svg";
export { ForwardRef as ReactComponent };